import React from 'react';
import { useDropdownToggle } from 'react-overlays';
import PropTypes from 'prop-types';

import Button from '../../Button/Button';
import ButtonTypes from '../../../constants/buttonTypes';

const Toggle = ({
  btnText, Icon, btnType, btnStyle, indicator, headerComponent
}) => {
  const [props, { toggle }] = useDropdownToggle();
  return (
    <div style={{ position: 'relative' }}>
      {indicator && <div className="w-[8px] h-[8px] bg-danger rounded-[5px] absolute top-[7px] right-[22px] z-[2]" />}
      {Icon
      && (
        <Button
          text={btnText}
          iconRight={Icon && <Icon className="w-[20px] h-[20px]" />}
          type={btnType}
          containerStyle={`text-[12px] px-[12px] ${btnStyle || ''}`}
          props={props}
          onClick={toggle}
        />
      )}
      {headerComponent && (
        <div
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...props}
          onClick={() => toggle()}
          className="aaa"
          role="presentation"
        >
          {headerComponent}
        </div>
      )}
    </div>

  );
};

Toggle.propTypes = {
  Icon: PropTypes.shape({}),
  btnText: PropTypes.string,
  btnType: PropTypes.string,
  btnStyle: PropTypes.string,
  indicator: PropTypes.bool,
  headerComponent: PropTypes.node,
};

Toggle.defaultProps = {
  Icon: null,
  btnText: '',
  btnType: ButtonTypes.PRIMARY,
  btnStyle: undefined,
  indicator: false,
  headerComponent: undefined
};

export default Toggle;
